import { FileManagerModeEnum } from "../../../../../interfaces/general";

export interface ContextMenuProps {
    mode: FileManagerModeEnum;
    fileInput?: any;
    folderInput?: any;
}

export const contextMenuState = {
    emptySelected: ["NEW_FOLDER", "FILE_UPLOAD", "FOLDER_UPLOAD", "LINK_UPLOAD", "EXCEL_UPLOAD"],

    dashboardSingleFolderSelected: ["CUT", "RENAME", "SHARE", "DOWNLOAD", "FILE_PARENT", "FAVORITE", "INFORMATION"],
    dashboardSingleFolderSelectedWithFavorite: ["CUT", "RENAME", "SHARE", "DOWNLOAD", "FILE_PARENT", "REMOVE_FAVORITE", "INFORMATION"],
    dashboardSingleFileSelected: ["COPY", "CUT", "RENAME", "SHARE", "LINK", "DOWNLOAD", "FILE_PARENT", "FAVORITE", "INFORMATION", "FILE_LINKS"],
    dashboardSingleFileSelectedWithFavorite: [
        "COPY",
        "CUT",
        "RENAME",
        "SHARE",
        "LINK",
        "DOWNLOAD",
        "FILE_PARENT",
        "REMOVE_FAVORITE",
        "INFORMATION",
        "FILE_LINKS"
    ],

    singleFileSelected: ["COPY", "CUT", "RENAME", "SHARE", "LINK", "DOWNLOAD", "VERSION", "FAVORITE", "INFORMATION", "TRASH", "FILE_LINKS"],
    singleFileSelectedWithFavorite: [
        "COPY",
        "CUT",
        "RENAME",
        "SHARE",
        "LINK",
        "DOWNLOAD",
        "VERSION",
        "REMOVE_FAVORITE",
        "INFORMATION",
        "TRASH",
        "FILE_LINKS"
    ],
    singleFolderSelected: ["CUT", "RENAME", "SHARE", "DOWNLOAD", "FAVORITE", "INFORMATION", "TRASH"],
    singleFolderSelectedWithFavorite: ["CUT", "RENAME", "SHARE", "DOWNLOAD", "REMOVE_FAVORITE", "INFORMATION", "TRASH"],

    multiFileSelected: ["COPY", "CUT", "DOWNLOAD", "FAVORITE", "TRASH"],
    multiFileSelectedWithFavorite: ["COPY", "CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],
    multiFolderSelected: ["CUT", "DOWNLOAD", "FAVORITE", "TRASH"],
    multiFolderSelectedWithFavorite: ["CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],
    multiFileAndFolderSelected: ["CUT", "DOWNLOAD", "FAVORITE", "TRASH"],
    multiFileAndFolderSelectedWithFavorite: ["CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],

    previewWithoutFavorite: ["COPY", "CUT", "SHARE", "DOWNLOAD", "FAVORITE"],
    previewWithFavorite: ["COPY", "CUT", "SHARE", "DOWNLOAD", "REMOVE_FAVORITE"],
    previewRootShareWriteAccess: ["COPY_MY_FILES", "SHARED_CUT", "DOWNLOAD"],
    previewShareWriteAccess: ["COPY", "COPY_MY_FILES", "SHARED_CUT", "DOWNLOAD"],
    previewShareReadAccess: ["DOWNLOAD", "COPY_MY_FILES"],
    trash: ["RESTORE", "DELETE"],

    favoriteSingleFileSelected: ["CUT", "RENAME", "SHARE", "LINK", "DOWNLOAD", "REMOVE_FAVORITE", "INFORMATION", "TRASH", "FILE_LINKS"],
    favoriteSingleFolderSelected: ["CUT", "RENAME", "SHARE", "DOWNLOAD", "REMOVE_FAVORITE", "INFORMATION", "TRASH"],
    favoriteMultiFileSelected: ["CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],
    favoriteMultiFolderSelected: ["CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],
    favoriteMultiFileAndFolderSelected: ["CUT", "DOWNLOAD", "REMOVE_FAVORITE", "TRASH"],

    sharedRootSingleFileReadAccess: ["COPY_MY_FILES", "DOWNLOAD", "UNSHARED"],
    sharedRootSingleFileWriteAccess: ["COPY_MY_FILES", "RENAME", "DOWNLOAD", "UNSHARED"],
    sharedRootSingleFolderReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedRootSingleFolderWriteAccess: ["RENAME", "DOWNLOAD", "UNSHARED"],
    sharedRootMultiFileReadAccess: ["COPY_MY_FILES", "DOWNLOAD", "UNSHARED"],
    sharedRootMultiFileWriteAccess: ["COPY_MY_FILES", "DOWNLOAD", "UNSHARED"],
    sharedRootMultiFolderReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedRootMultiFolderWriteAccess: ["DOWNLOAD", "UNSHARED"],
    sharedRootMultiFolderAndFileReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedRootMultiFolderAndFileWriteAccess: ["DOWNLOAD", "UNSHARED"],

    sharedSingleFileReadAccess: ["COPY_MY_FILES", "DOWNLOAD", "UNSHARED"],
    sharedSingleFileWriteAccess: ["COPY", "COPY_MY_FILES", "RENAME", "SHARED_CUT", "DOWNLOAD", "UNSHARED"],
    sharedSingleFolderReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedSingleFolderWriteAccess: ["RENAME", "SHARED_CUT", "DOWNLOAD", "UNSHARED"],
    sharedMultiFileReadAccess: ["COPY_MY_FILES", "DOWNLOAD", "UNSHARED"],
    sharedMultiFileWriteAccess: ["COPY", "COPY_MY_FILES", "SHARED_CUT", "DOWNLOAD", "UNSHARED"],
    sharedMultiFolderReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedMultiFolderWriteAccess: ["SHARED_CUT", "DOWNLOAD", "UNSHARED"],
    sharedMultiFolderAndFileReadAccess: ["DOWNLOAD", "UNSHARED"],
    sharedMultiFolderAndFileWriteAccess: ["SHARED_CUT", "DOWNLOAD", "UNSHARED"],

    singleDuplicatedFileSelected: [
        "COPY",
        "CUT",
        "RENAME",
        "SHARE",
        "LINK",
        "DOWNLOAD",
        "VERSION",
        "FAVORITE",
        "INFORMATION",
        "FILE_PARENT",
        "TRASH"
    ],
    singleDuplicatedFileSelectedWithFavorite: [
        "COPY",
        "CUT",
        "RENAME",
        "SHARE",
        "LINK",
        "DOWNLOAD",
        "VERSION",
        "REMOVE_FAVORITE",
        "INFORMATION",
        "FILE_PARENT",
        "TRASH"
    ]
};
